import { Nullable, UnionRight } from "../common/common.types";
import { Paginatable } from "../common/Paginatable.dto";
import { GlobalPrivilege } from "../ref/Ref.dto";
import { User as UserSSO } from "../sso/User.dto";

export class User extends UserSSO {}

export enum UserInfoAvatarBgColor {
  Gray050 = "#878D96",
  Purple050 = "#A56EFF",
  Progress050 = "#1F3F5E",
  LinkText = "#0D7BDC",
  Progress020 = "#51BEFF",
  Blue060 = "#0B86B2",
  PositiveSecondary = "#42BE65",
  Yellow040 = "#FFCD19",
  ProgreesHigh = "#FF8A00",
  NegativePrimary = "#FA4D56",
}

export class UserInfo {
  agreeMarketing: boolean;
  privileges: Array<GlobalPrivilege>;
  avatarBgColor: Nullable<UserInfoAvatarBgColor>;
  avatarImageKey: Nullable<string>;
  avatarImageBucket: Nullable<string>;
}

export type UserInfoEssential = Pick<UserInfo, "agreeMarketing" | "avatarBgColor">;

export enum UserType {
  User = "USER",
  Ecoa = "ECOA",
  Api = "API",
}

export type UserWithInfo = User & { info: Omit<UserInfo, "avatarImageKey" | "avatarImageBucket"> };
export type UserWithInfoEssential = User & { info: UserInfoEssential };

export class PatchMyInfoRequest {
  currentPassword: string;

  name?: string;
  phone?: string;
  language?: string;
  newPassword?: string;

  agreeMarketing: boolean;
}

export class PatchMyInfoResponse {
  user: UserWithInfoEssential;
}

export class GetUserRequest {
  userId: bigint;
}

export type UserWithInfoEssentialWithAvatar = UnionRight<
  UserWithInfo,
  { info: Omit<UserInfo, "avatarImageKey" | "avatarImageBucket"> & { avatarImageUrl?: string } }
>;

export type GetUserByIdResponse = User;
export type GetUserRequestByToken = {};
export type GetUserResponseByToken = UserWithInfoEssentialWithAvatar;

export class GetUsersRequest {
  email?: string;
  userIds?: bigint[];
  userId?: bigint;
  onlyCompanions?: boolean;
}

export class GetUsersResponse {
  users: User[];
}

export class PaginateUsersRequest {
  page: number;
  rpp: number;
}

export type PaginateUsersResponse = Paginatable<User>;

export const UserEmailMaxLength = 128;
export const UserPasswordMaxLength = 128;
